<template>
  <div class="notNull">
    <div class="fzfbox">
      <strong>{{title}}</strong>
      <div>{{type=='coupons'? $t('base.noCoupons'):text}}</div>
      <router-link class="howtogetbtn" :to="{path:'/howcoupon'}" v-if="type=='coupons'">{{$t('symbol.howToGet')}}</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'notNull',
  data() {
    return {}
  },
  props: {
    title: '',
    text: '',
    type:''
  },
  mounted(){
  },
  created() {
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notNull {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.notfind {
  height: 450px;
}


.pay {
  height: auto;
  margin-top: 30%;
  margin-bottom: 20px;
}

.fzfbox {
  width: 100%;
  padding-top: 190px;
  text-align: center;
  background: url(../../static/images/empty.svg) center 0 no-repeat;
  font-size: 18px;
  line-height: 2;
}
.howtogetbtn{
  font-size: 14px;
  width: 210px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 4px;
  background: #5F6DAE;
  display: inline-block;
  margin-top: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/notnull.vue